import { IconProps } from '@/components/Icon';

export const IconSliders = ({ width = 20, height = 20, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg
      {...props}
      fill='none'
      height={height}
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      viewBox='0 0 24 24'
      width={width}
      xmlns='http://www.w3.org/2000/svg'>
      <line x1='4' x2='4' y1='21' y2='14'></line>
      <line x1='4' x2='4' y1='10' y2='3'></line>
      <line x1='12' x2='12' y1='21' y2='12'></line>
      <line x1='12' x2='12' y1='8' y2='3'></line>
      <line x1='20' x2='20' y1='21' y2='16'></line>
      <line x1='20' x2='20' y1='12' y2='3'></line>
      <line x1='1' x2='7' y1='14' y2='14'></line>
      <line x1='9' x2='15' y1='8' y2='8'></line>
      <line x1='17' x2='23' y1='16' y2='16'></line>
    </svg>
  );
};
